export function getDomainFromWebsite(website) {
  if (website && website.indexOf('.') > -1) {
    if (website.indexOf('http') == -1) {
      website = 'https://' + website // new url method will throw error if http is not there in website
    }
    const url = new URL(website)
    let host = url.host
    return host
  }
}
